import React from "react";

export const EditSingleAmount = () => {
  return <div>Edit single amount help modal</div>;
};

export default EditSingleAmount;
